import React, { useState } from 'react';
import { Paper, Table, TableBody, TableContainer, Typography } from '@material-ui/core';

import DeviceCategoryRow from './DeviceCategoryRow';
import SerialNumberPopover from './SerialNumberPopover';
import useDataService from '../../hooks/useDataService';
import { DeviceCategoryHeader } from './DeviceCategoryHeader';

import { CATEGORIES } from './utils';

import { eMessageType } from '../../types/IMessageType';
import { IGeneratedDevice, IGroupedDevices, IItem } from '../../views/PxwProcessDevices/types';

interface IResultsTableProps {
  groupedDevices: IGroupedDevices;
  selectedItem: IItem | null;
}

const ResultsTable: React.FC<IResultsTableProps> = ({ groupedDevices, selectedItem }) => {
  const { openSnackBar } = useDataService();
  const [copiedCategory, setCopiedCategory] = useState<IGeneratedDevice['testCategory'] | null>(
    null
  );
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLElement | null>(null);
  const [popoverCategory, setPopoverCategory] = useState<IGeneratedDevice['testCategory'] | null>(
    null
  );

  const totalDevices = CATEGORIES.reduce((sum, cat) => sum + groupedDevices[cat].totalCount, 0);

  const handleCopyAll = (cat: IGeneratedDevice['testCategory']) => {
    navigator.clipboard.writeText(
      groupedDevices[cat].serialItems.map((d) => d.serialId).join(', ')
    );
    setCopiedCategory(cat);
    openSnackBar('Copied to clipboard', eMessageType.success);
    setTimeout(() => setCopiedCategory(null), 2000);
  };

  const handleOpenPopover = (
    e: React.MouseEvent<HTMLElement>,
    cat: IGeneratedDevice['testCategory']
  ) => {
    setPopoverAnchor(e.currentTarget);
    setPopoverCategory(cat);
  };

  return (
    <div className="cell">
      <div className="pxw-process-devices__results-header margin-bottom-1">
        <Typography variant="subtitle1">
          Test Results summary for <strong>{selectedItem?.itemNumber}</strong> — {totalDevices}{' '}
          devices
        </Typography>
      </div>
      <TableContainer
        component={Paper}
        variant="outlined"
        className="pxw-process-devices__table-container">
        <Table size="small" style={{ tableLayout: 'fixed' }}>
          <DeviceCategoryHeader />
          <TableBody>
            {CATEGORIES.map((cat) => {
              const group = groupedDevices[cat];
              if (group.serialItems.length === 0) return null;
              return (
                <DeviceCategoryRow
                  key={cat}
                  cat={cat}
                  group={group}
                  isCopied={copiedCategory === cat}
                  onCopyAll={() => handleCopyAll(cat)}
                  onOpenPopover={(e) => handleOpenPopover(e, cat)}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {popoverCategory && (
        <SerialNumberPopover
          anchor={popoverAnchor}
          category={popoverCategory}
          group={groupedDevices[popoverCategory]}
          onClose={() => {
            setPopoverAnchor(null);
            setPopoverCategory(null);
          }}
        />
      )}
    </div>
  );
};

export default ResultsTable;
